import { ScanFace, Fingerprint, KeyRound, KeySquare } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionHead } from "@/components/apex/primitives";

const ICONS = [ScanFace, Fingerprint, KeySquare, KeyRound];

const SmartAccess = () => {
  const { t } = useLang();
  return (
    <section id="features" data-testid="smart-access-section" className="relative py-14 sm:py-20">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHead align="center" label={t.smart.label} title={t.smart.title} body={t.smart.body} />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.smart.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.t} delay={0.06 * i}>
                <div data-testid={`smart-item-${i}`} className="ap-card-soft ap-card-hover group h-full p-7">
                  <span className="ap-icon h-16 w-16">
                    <Icon className="h-7 w-7" strokeWidth={1.6} />
                  </span>
                  <h3 className="ap-display mt-7 text-xl text-[var(--text)]">{item.t}</h3>
                  <p className="mt-3 text-[14px] leading-[1.8] text-[var(--muted)]">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-center text-[13.5px] text-[var(--muted)]">{t.smart.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default SmartAccess;
